import React, { useState, useEffect } from "react";
import { BackTop  } from 'antd';
import { useSelector } from "react-redux";
import useWindowResize from '../../hooks/useWindowResize';
import { FOOTER_H, ICP_RECORD_CODE_LINK, PUBLIC_RECORD_CODE_LINK } from '../../config/constant';
// import './style/footer.less';


const officialAccountImg = require("../../assets/images/officialAccount.png");
const smallProgramImg = require("../../assets/images/smallProgram.png");

const backTopImg = require('../../assets/images/BackTop.png');

// 一些公司信息
const COMPANY_NAME = '基准方中建筑设计股份有限公司';
const COMPANY_ADDRESS = '成都市青羊区光华西五路58号天府匠芯北区A座';
const COMPANY_PHONE = '028-86333715';
const COMPANY_EMAIL = 'pr@jzfz.com';
// const COPY_NUM = '© 2025基准方中 蜀ICP备05029532号 ｜ 川公网安备51010502015152号';
const ICP_RECORD_TEXT = '2025基准方中 蜀ICP备05029532号';
const PUBLIC_RECORD_TEXT = '川公网安备51010502015152号';


/**
 * footer
 * @returns 
 */
const Footer = () => {

	const { isMobile } = useSelector((state: any) => state.reducer);

	const [winSize, setWinSize] = useState(window.innerWidth);

	// 窗口大小变化
	useWindowResize((bodyRect) => {
		const { width } = bodyRect || {};
		setWinSize(width);
	});


	/**
	 * mobile footer
	 */
	const MobileFooter = () => (
		<div className="plr5" style={{background: '#232323'}}>
			<div className="flexic flexjc f12 pt40 pb20" style={{color: '#808080'}}>
				<div className="tc">
					<img src={officialAccountImg} className="mb8 w90 h90" loading="lazy" />
					<p>基准方中官方公众号</p>
				</div>
				<div className="tc ml24">
					<img src={smallProgramImg} className="mb8 w90 h90" loading="lazy" />
					<p>基准方中小程序</p>
				</div>
			</div>
			<div className="f20 tc pb20" style={{color: '#A8A8A8'}}>
				<span className="pr12">基于心</span>
				<span className="pr12">准于行</span>
				<span className="pr12">创造价值</span>
				<span className="pr12">成就梦想</span>
			</div>
			<div className="f16 tc pb20" style={{color: '#A8A8A8'}}>
				<p>{COMPANY_NAME}</p>
				<p>{COMPANY_ADDRESS}</p>
			</div>
			<div className="f16 tc pb20" style={{color: '#A8A8A8'}}>
				<p>联系电话</p>
				<p>{COMPANY_PHONE}</p>
			</div>
			<div className="f16 tc pb20" style={{color: '#A8A8A8'}}>
				<p>邮箱</p>
				<p>{COMPANY_EMAIL}</p>
			</div>
			<div className="f16 tc tc pb28" style={{color: '#757575'}}>
				<div><a className="outlink" href={ICP_RECORD_CODE_LINK} target="_blank">@&nbsp;{ICP_RECORD_TEXT}</a></div>
				<div><a className="outlink" href={PUBLIC_RECORD_CODE_LINK} rel="noreferrer" target="_blank">{PUBLIC_RECORD_TEXT}</a></div>
			</div>
		</div>
	);


	/**
	 * PAD footer
	 */
	const PADFooter = () => {
		return (
			<div className="plr40 ptb50" style={{background: '#232323'}}>
				<div className="flexjs">
					<div className="" style={{color: '#A8A8A8'}}>
						<div className="f22">
							<span className="pr12">基于心</span>
							<span className="pr12">准于行</span>
							<span className="pr12">创造价值</span>
							<span className="pr12">成就梦想</span>
						</div>
						<div className="f16 mt24">
							<p>{COMPANY_NAME}</p>
							<p>{COMPANY_ADDRESS}</p>
						</div>
						<div className="f16 mt18">
							<p>联系电话</p>
							<p>{COMPANY_PHONE}</p>
						</div>
						<div className="f16 mt18">
							<p>邮箱</p>
							<p>{COMPANY_EMAIL}</p>
						</div>
					</div>
					<div className="tc" style={{width: 280, color: '#808080'}}>
						<div className="dib">
							<img src={officialAccountImg} className="mb8 w90 h90" loading="lazy" />
							<p>基准方中官方公众号</p>
						</div>
						<div className="dib ml24">
							<img src={smallProgramImg} className="mb8 w90 h90" loading="lazy" />
							<p>基准方中小程序</p>
						</div>
					</div>
				</div>
				<div className="h80 flexic flexjc" style={{color: '#757575'}}>
					<span className="pr5">©</span>
					<a className="outlink" href={ICP_RECORD_CODE_LINK} target="_blank">{ICP_RECORD_TEXT}</a>
					<span className="plr8">｜</span>
					<a className="outlink" href={PUBLIC_RECORD_CODE_LINK} rel="noreferrer" target="_blank">{PUBLIC_RECORD_TEXT}</a>
				</div>
			</div>
		);
	};


	/**
	 * PC footer
	 */
	const PCFooter = () => (
		<div className="plr40 ptb58 flexjs" style={{height: FOOTER_H, background: '#232323'}}>
			<div className="flex1 flexie flexjs">
				<div style={{width: '45%', color: '#A8A8A8'}}>
					<div className="f22">
						<span className="pr12">基于心</span>
						<span className="pr12">准于行</span>
						<span className="pr12">创造价值</span>
						<span className="pr12">成就梦想</span>
					</div>
					<div className="flexjs f16 mt24">
						<div>
							<p>{COMPANY_NAME}</p>
							<p>{COMPANY_ADDRESS}</p>
						</div>
						<div>
							<p>联系电话</p>
							<p>{COMPANY_PHONE}</p>
						</div>
						<div>
							<p>邮箱</p>
							<p>{COMPANY_EMAIL}</p>
						</div>
					</div>
				</div>
				<div className="f16 flexic" style={{width: '45%', color: '#757575'}}>
					<span className="pr5">©</span>
					<a className="outlink" href={ICP_RECORD_CODE_LINK} target="_blank">{ICP_RECORD_TEXT}</a>
					<span className="plr8">｜</span>
					<a className="outlink" href={PUBLIC_RECORD_CODE_LINK} rel="noreferrer" target="_blank">{PUBLIC_RECORD_TEXT}</a>
				</div>
			</div>
			<div className="flexic f12" style={{width: 280, color: '#808080'}}>
				<div className="tc">
					<img src={officialAccountImg} className="mb8 w90 h90" loading="lazy" />
					<p>基准方中官方公众号</p>
				</div>
				<div className="tc ml24">
					<img src={smallProgramImg} className="mb8 w90 h90" loading="lazy" />
					<p>基准方中小程序</p>
				</div>
			</div>
		</div>
	);

	return (
		<>

			{/* PC	 */}
			{winSize >= 1660 && <PCFooter />}

			{/* PAD */}
			{winSize > 1024 && winSize < 1660 && <PADFooter />}

			{/* MOBILE */}
			{winSize <= 1024 && <MobileFooter />}


			{/* 回到顶部 */}
			<BackTop>
				<img src={backTopImg} title="回到顶部" loading="lazy" />
			</BackTop>
		</>
	);
}


export default Footer;
